import React from 'react';
import PropTypes from 'prop-types';
import { Route as ReactRouterRoute, Redirect } from 'react-router-dom';
import _ from 'lodash';

import Auth from '../Auth';

const Route = ({ protectedRoute, userTypesAllowed, ...routeProps }) => (
  // showLoader props ensure that the user info and user authenticated info is
  // completely loaded rendering the routes
  <Auth showLoader>
    {({ authState }) => {
      // redirect to login if the route is protected
      // and the user is not authenticated
      if (protectedRoute) {
        if (!authState.userAuthenticated) {
          return (
            <Redirect
              to={{
                pathname: '/login',
              }}
            />
          );
        }

        // redirect to 404 page if the user type is not allowed
        // and the user is still trying to access it
        if (
          authState.authenticatedUserInfo
          && !_.includes(userTypesAllowed, authState.authenticatedUserInfo.type)
        ) {
          return (
            <Redirect
              to={{
                pathname: '/404',
              }}
            />
          );
        }

        // render the route if all the conditions are passed
        return <ReactRouterRoute {...routeProps} />;
      }
      // render the route if all the conditions are passed
      return <ReactRouterRoute {...routeProps} />;
    }}
  </Auth>
);

Route.propTypes = {
  protectedRoute: PropTypes.bool,
  userTypesAllowed: PropTypes.arrayOf(PropTypes.oneOf(['ADMIN', 'CITY_IMPACT_MANAGER'])),
};

Route.defaultProps = {
  protectedRoute: false,
  userTypesAllowed: [],
};

export default Route;



// WEBPACK FOOTER //
// ./src/components/Route/Route.js